<template>
  <div class="report">
    <h3 class="title">试题错误率</h3>
    <div class="ask" v-if="reportList.length">
      <div class="ask-wrap" @click="check(report)" v-for="report in reportList">
        <div class="ask-up"
             :style="{backgroundImage: 'linear-gradient(to right, transparent ' + (100-report.wrong_rate) +'%, #FF676C 0)'}">
          <span>{{parseInt(report.wrong_rate)}}% </span>
        </div>
        <div class="ask-down"><span v-if="report.q_no">{{report.q_no}}</span><span v-if="report.a_no">({{report.a_no}})</span>题
        </div>
      </div>
    </div>
    <div class="noresources" v-else>
      <div v-cloak>
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    data() {
      return {}
    },
    props: ['reportList', 'knows'],
    components: {},
    methods: {
      check(ask) {
        //单题
        this.$emit('child', ask);
      }
    },
    created() {

    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "./src/assets/scss/common/_mixin";

  .report {
    .title {
      padding: 0 24px/$ppr;
      height: 96px/$ppr;
      line-height: 96px/$ppr;
      font-size: 36px/$ppr;
      color: #333;
      background: #fff;
    }
    .know_list {
      padding: 32px/$ppr 0;
      width: 100%;
      border-top: 1px/$ppr solid #E8E8E8;
      background: #fff;
      p {
        display: flex;
        align-items: center;
        width: 672px/$ppr;
        line-height: 50px/$ppr;
        margin: 0 auto;
        .knows-tit {
          width: 576px/$ppr;
          font-size: 30px/$ppr;
          word-wrap: break-word;
          word-break: break-all;
          color: #999;
        }
        .knows-per {
          flex: 1;
          color: #28cd85;
          text-align: right;
        }
        .knows-num {
          flex: 1;
          color: #999;
          text-align: right;
          i {
            color: #FF6600;
          }
        }
      }
    }
    .ask {
      width: 100%;
      padding-top: 24px/$ppr;
      margin-bottom: 24px/$ppr;
      border-top: 1px/$ppr solid #E8E8E8;
      background: #fff;
      background-color: $c-fbg;
      flex-wrap: wrap;
      @include displayFlex();
      .ask-wrap {
        width: 20%;
        text-align: center;
        margin-bottom: 30px/$ppr;
        .ask-up {
          margin: 0 auto;
          height: 100px/$ppr;
          width: 100px/$ppr;
          border-radius: 100px/$ppr;
          background-color: $c-hbg;
          position: relative;
          span {
            display: block;
            width: 86px/$ppr;
            height: 86px/$ppr;
            line-height: 90px/$ppr;
            border-radius: 90px/$ppr;
            color: #FF676C;
            text-align: center;
            background-color: $c-fbg;
            position: absolute;
            top: 7px/$ppr;
            left: 7px/$ppr;
          }
        }
        .ask-down {
          margin-top: 12px/$ppr;
          display: inline-block;
          color: $c-light;
        }
      }
    }
    .noresources {
      width: 100%;
      height: 300px/$ppr;
      p {
        line-height: 300px/$ppr;
        text-align: center;
      }
    }
    [v-cloak] {
      display: none !important;
    }
  }
</style>
